import { useEffect, useRef, useState } from "react";
import { useSendLink } from "@/app/notebookQueries";
import { COPY_RESET_MS } from "@/ui/CodeBlock";
import { errorInfo } from "@/routes/step/model";

/** Текст макета S8 дословно (правило 9: честно объясняем, почему только чтение). */
export const READONLY_TEXT = "Решать домашку с телефона не выйдет: нужен редактор и запуск ячеек. Открой ноутбук с компьютера — ссылка уже отправлена в Telegram.";

const btn = "flex-1 cursor-pointer rounded-[5px] border bg-transparent p-[11px] font-mono text-[12px]";

/** Dashed-коллаут «только чтение» с кнопками «прислать ссылку» и «скопировать путь». */
export function ReadOnlyCallout({ assignmentId }: { assignmentId: string }) {
  const send = useSendLink(assignmentId);
  const [copied, setCopied] = useState(false);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch {
      /* без clipboard API кнопка всё равно показывает состояние */
    }
    setCopied(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setCopied(false), COPY_RESET_MS);
  };

  const onSend = () => {
    if (send.isPending) return;
    send.mutate();
  };

  return (
    <section className="rounded-lg border border-dashed border-bd2 bg-card p-3.5" data-testid="readonly-callout">
      <div className="mb-2 font-mono text-[10.5px] uppercase tracking-[.06em] text-warn">только чтение</div>
      <p className="m-0 text-pretty text-[13px] leading-[1.5] text-ink2">{READONLY_TEXT}</p>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={onSend} aria-busy={send.isPending} className={`${btn} border-bd2 text-ink hover:border-acc hover:text-acc`}>
          {send.isPending ? "отправляем…" : "прислать ссылку"}
        </button>
        <button type="button" onClick={copy} className={`${btn} ${copied ? "border-ok bg-oksoft text-ok" : "border-bd2 text-ink2 hover:border-acc hover:text-acc"}`}>
          {copied ? "✓ скопировано" : "скопировать путь"}
        </button>
      </div>
      <div aria-live="polite" data-testid="send-link-status">
        {send.isSuccess && <p className="m-0 mt-2.5 font-mono text-[11.5px] leading-[1.5] text-ok">ссылка отправлена в Telegram</p>}
        {send.isError && <p className="m-0 mt-2.5 text-[12px] leading-[1.5] text-err">{errorInfo(send.error).message}</p>}
      </div>
    </section>
  );
}
